/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Skeleton } from './Skeleton';
export var TextSkeleton = function (_a) {
    var className = _a.className, line = _a.line;
    return (jsx(Skeleton, { className: className, as: "span", sx: {
            height: '1em',
            width: line ? undefined : 80,
            display: line ? 'block' : 'inline-block',
            borderRadius: 5,
            mb: line ? 1 : 0,
        } }));
};
//# sourceMappingURL=TextSkeleton.js.map